import { Score } from '../../../models/view/score';
import { PagePath } from '../../../navigation/navigation.enums';
import { PermissionsEntity } from '../permissions-entity-dropdown/permissions-entity-dropdown.models';

export interface ISkillsBreakdownWidgetProps {
  entity: PermissionsEntity | undefined;
  path: PagePath.analyticsOverview | PagePath.analyticsDepartment | PagePath.analyticsTeam | PagePath.analyticsPerson | PagePath.analyticsSkills | PagePath.dashboard;
  description?: string;
}

export interface SkillsBreakdownSkill {
  name: string;
  slug: string;
  score: Score | undefined;
  comparisonScore: Score | undefined;
  peopleCount: number | undefined;
  skillSubTypeSlug: string;
}

export enum SortbyMenuEnum {
  Ascending = '0',
  Descending = '1',
  Organic = '2'
}
